<template>
  <div id="guest-sale">
    <div class="flex justify-space-between align-center">
      <h2 class="title"></h2>
      <router-link to="/" class="link">
        &lt; Regresar
      </router-link>
    </div>
    <div class="card flex dspl-block-sm">
      <section class="card-section grow-1">
        <div class="flex justify-space-between dspl-block-m dspl-block-sm">
          <h3> Detalle de la compra </h3>
        </div>
        <div id="textTitleContentRight">
          <p>Producto: {{ productName }} </p>
          <p>{{ identifierText }}</p>
          <p>Saldo que abonará: {{ formattedPrice }} </p>
          <p>Monto total a pagar: {{ formattedTotal }} </p>
          <hr/>
           <div v-if="paymentCanProceed">
            <p>Si usted está de acuerdo con esta compra, ingrese el código de su tarjeta para finalizar el proceso</p>
            <p><label>Tarjeta</label> <input v-model="cardNumber" type="text" disabled></p>
            <p><label>Expiración</label> <input v-model="cardExpirationDate" type="text" disabled></p>
            <p><label>Cvv</label> <input v-model="cardCvv" type="text" maxlength="4" placeholder="Cvv"></p>

            <button @click="validateForm" class="btn accept" :disabled="isButtonDisabled">Confirmar compra</button><br/>
            <router-link to="/">
              <button class="btn cancel">Cancelar</button>
            </router-link>
          </div>
          <div v-if="paymentCannotProceed">
            <p>No es posible proceder con la transacción</p>
            <p>Motivo: {{ rationaleMessage }}</p>
            <router-link to="/">
              <button class="btn accept">Regresar</button>
            </router-link>
          </div>
          <div v-if="!isIVKeyValid">
            <p>No es posible proceder con la transacción</p>
            <p>Motivo: Esta compra ha expirado, favor de crear una nueva orden para proceder con el pago.</p>
            <router-link to="/">
              <button class="btn accept">Regresar</button>
            </router-link>
          </div>
        </div>
      </section>
    </div>
    <InformationModal
      @confirm="onModalClose"
      :active="showModal"
      title="Atención"
    >
      <template #content>
        {{ modalContent }}
      </template>
    </InformationModal>
    <ConfirmationModal
      @confirm="submitForm"
      @cancel="closeConfirmationModal"
      :active="showConfirmationModal"
      :message="confirmationModalText"
      cancel-text="Corregir CVV"
      confirm-text="Realizar el cobro"
    />
    <LoadingModal
      :active="isProcessing"
      title="Espere un momento"
    >
      <template slot="content">
        <p> Estamos procesando su cargo. . . </p>
      </template>
    </LoadingModal>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import ConfirmationModal from '@/components/ConfirmationModal'
import InformationModal from '@/components/InformationModal'
import LoadingModal from '@/components/LoadingModal'

export default {
  name: 'GuestCard',
  components: {
    ConfirmationModal,
    InformationModal,
    LoadingModal
  },
  data () {
    return {
      errors: {},
      isButtonDisabled: false,
      modalContent: '',
      showModal: false,
      isProcessing: false,
      showConfirmationModal: false
    }
  },
  computed: {
    ...mapState('guestSaleDetail', [
      'processed',
      'productName',
      'rationale',
      'status',
      'validToProcess',
      'showDisplayTutorial'
    ]),
    ...mapGetters('guestSaleDetail', [
      'cardExpirationDate',
      'cardNumber',
      'formattedNewBalance',
      'formattedPrice',
      'formattedTotal',
      'formattedCommissionAmount',
      'isIVKeyValid',
      'identifier',
      'isTag',
      'rationaleMessage'
    ]),
    cardCvv: {
      get () { return this.$store.state.guestSaleDetail.cardCvv },
      set (value) { this.updateCardCvv(value) }
    },
    confirmationModalText () {
      return `Ahora realizaremos el cobro a tu tarjeta, confirma que tu CVV es el siguiente: ${this.cardCvv}`
    },
    paymentCanProceed () {
      return this.validToProcess && this.isIVKeyValid && (this.processed === false)
    },
    paymentCannotProceed () {
      return !this.validToProcess && this.isIVKeyValid && (this.processed === false)
    },
    identifierText () {
      if (this.isTag) {
        return `Tarjeta: ${this.identifier}`
      } else {
        return `TAG: ${this.identifier}`
      }
    }
  },
  watch: {
    processed (newValue, _) {
      if (newValue) {
        this.$nextTick(() => {
          this.changeModalMessage()
          this.isProcessing = false
          this.showModal = true
        })
      }
    }
  },
  methods: {
    ...mapActions('guestSaleDetail', [
      'performPayment',
      'updateCardCvv'
    ]),
    changeModalMessage: function (message) {
      let content = 'Ocurrio un error inesperado, intenta nuevamente'

      if (message) {
        this.modalContent = message
      } else {
        switch (this.status) {
          case 'Duplicada':
            content = 'Su pago ya fue procesado, favor de contactar con personal de la línea Exprés en caso de cualquier duda.'
            break
          case 'Authenticada':
            content = 'Ocurrio un error y no se efectuo tu pago, intente nuevamente.'
            break
          case 'Rechazada':
            content = 'Lo sentimos, se rechazó el cobro, intente nuevamente.'
            break
          case 'Procesada':
            content = 'Listo, se ha procesado tu compra, revisa el correo electrónico que ingresaste para encontrar tu comprobante.'
            break
        }

        this.modalContent = content
      }
    },
    clearErrors () {
      this.errors = {}
    },
    disableButton () {
      this.isButtonDisabled = true
    },
    enableButton () {
      this.isButtonDisabled = false
    },
    onModalClose: function () {
      this.showModal = false
      this.$router.push('/vehicles')
    },
    async submitForm () {
      this.showConfirmationModal = false
      this.isProcessing = true

      await this.performPayment()
    },
    closeConfirmationModal () {
      this.showConfirmationModal = false
      this.enableButton()
    },
    validateForm () {
      this.disableButton()
      this.clearErrors()

      if (!this.cardNumber) {
        this.errors = {
          ...this.errors,
          cardNumber: [
            'El número de tarjeta no es válido'
          ]
        }
      }
      if (!this.cardExpirationDate) {
        this.errors = {
          ...this.errors,
          cardExpirationDate: [
            'La fecha de expiración de la tarjeta no es válida'
          ]
        }
      }
      if (!this.cardCvv || this.cardCvv.length < 3) {
        this.errors = {
          ...this.errors,
          cardCvv: [
            'La clave de verificación(CVV) de la tarjeta no es válida'
          ]
        }
      }

      if (Object.keys(this.errors).length === 0) {
        if (this.showDisplayTutorial) {
          this.showConfirmationModal = true
          return
        }
        this.isProcessing = true
        this.submitForm()
      }

      this.enableButton()
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/constants.scss';

#guest-sale {
  color: $grey;
  text-align: start;
  margin: 1rem 2rem;
  height: 100vh;
}

.title {
  text-align: start;
  color: $grey;
}

.link {
  color: $blue;
  text-decoration: none;
  font-style: italic;
}

.card {
  border-radius: 25px;
  background-color: $white;
  width: 80%;
  margin-left: 10%;
  margin-right: 10%;
}

.card.with-form {
  width: 80%;
}

.card-section {
  padding: 1.25rem 2rem;
}

.center-text {
  text-align: center;
}

.btn {
  font-size: 0.75rem;
  border-radius: 20px;
  padding: 0.5rem 1.5rem;
  border: 1px solid $light-blue;
  cursor: pointer;

  &:focus {
    outline-width: 0;
  }

  &.accept {
    color: $white;
    font-size: 1rem;
    margin: 1rem;
    background-color: $light-blue;
  }

  &.cancel {
    margin: 1rem;
    font-size: 1rem;
    color: $light-blue;
    background-color: $white;
  }

  &:disabled {
    background-color: #8f919d;
    border: 1px solid #8f919d;
    cursor: inherit;
  }
}

hr {
  border: 1px solid $grey;
  margin-block-start: 1.25rem;
  margin-block-end: 1.25rem;
  margin-inline-start: 0;
  margin-inline-end: 0;
}
.whalf {
  width: 50%;
}
@media screen and (max-width: 960px) {
  input, label {
    font-size: 1.2rem;
    min-width: 40%;
    text-align: left;
  }
  .card {
    margin-left: 0;
    margin-right: 0;
  }
   button.btn {
    font-size: 1.2rem;
    width: 100%;
    margin-bottom: 0.5em;
    margin-top: 0.5em;
  }
  .btn.cancel {
    margin-left: 0;
  }
}
@media screen and (max-width: 60rem) {
  .link {
    display: none;
  }

  .card {
    width: 100%;
  }

  .vehicle-information {
    width: auto;
  }

  .btn {
    &.accept {
      margin-left: 0;
    }

    &.cancel {
      margin-right: 0;
    }
  }

  h2 {
    font-size: 1.25rem;
  }

  hr {
    margin-block-start: 0rem;
    margin-block-end: 0rem;
    margin-inline-start: 1.25rem;
    margin-inline-end: 1.25rem;
  }
}
</style>
